import { useTheme } from 'vuetify'

import { type ThemeName } from '@/constants/practiceConstants'
import store from '@/store'

/** Switch the app theme and save it to the user's profile; if saving fails the previous theme comes back. */
export function useThemeSelection() {
  const vueTheme = useTheme()

  const isCurrentTheme = (theme: ThemeName) => vueTheme.global.name.value === theme

  async function selectTheme(theme: ThemeName): Promise<boolean> {
    const previousTheme = vueTheme.global.name.value
    vueTheme.global.name.value = theme
    const saved = await store.dispatch.user.updateTheme({ theme })
    if (!saved) {
      vueTheme.global.name.value = previousTheme
    }
    return saved
  }

  return { isCurrentTheme, selectTheme }
}
